import HttpService from '../baseHttp'

// export const HttpAddRemark = (data = {}) => HttpService.post('/api/v2/B2cOrder/addRemark', data)
// export const HttpUpdateSfp = (data = {}) => HttpService.post('/api/v2/orderPackage/saveOne', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_BOSS });
// export const HttpResubmit = (data = {}) => HttpService.get('/api/v2/B2cOrder/reSubmit', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })


// 查询summary列表
export const HttpGetSummarylist = (data = {}) => HttpService.get('/api/v2/serviceSummary/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 创建、编辑单条summary
export const HttpsaveOneSummary = (data = {}) => HttpService.post('/api/v2/serviceSummary/saveOne', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 查看单条summary
export const HttpGetOneSummary = (data = {}) => HttpService.get('/api/v2/serviceSummary/findOne', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 删除单条summary
export const HttpDeleteOneSummary = (data = {}) => HttpService.get('/api/v2/serviceSummary/delete', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 获取erpsku
export const HttpGetErpsku = (data = {}) => HttpService.get('/api/v1/Product/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 根据flag、sellersku、erpsku获取渠道产品
export const HttpGetFlagAndSku = (data = {}) => HttpService.get('/api/v1/ProductChannel/findByFlagAndSku', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 附件上传、删除
export const HttpOneSummaryLog = (data = {}) => HttpService.post('/api/v2/serviceSummary/uploadAnnex', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_BOSS });
export const HttpDeleteOneSummaryLog = (data = {}) => HttpService.get('/api/v2/serviceSummary/delete', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 售后单
// 查询列表
export const HttpGetAfSaleslist = (data = {}) => HttpService.get('/api/v2/orderSerivce/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 单条查看/编辑
export const HttpGetOneafSales = (data = {}) => HttpService.get('/api/v2/orderSerivce/findOne', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpsaveOneafSales = (data = {}) => HttpService.post('/api/v2/orderSerivce/saveOne', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_BOSS });
// 根据单号带出订单详情信息/售后单关联信息列表
export const HttpGetOrderNo = (data = {}) => HttpService.get('/api/v2/orderSerivce/findServiceByOrderNo', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

//补发单重送
export const HttpGetrePush = (data = {}) => HttpService.get('/api/v2/orderSerivce/rePushReplacement', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 作废/归档
export const HttpGetChangeStatus = (data = {}) => HttpService.get('/api/v2/orderSerivce/changeStatus', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 退货的重送
export const HttpGoodsPush = (data = {}) => HttpService.get('/api/v2/orderSerivce/rePushReturn', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })


// 仓库发运方式
export const HttpWarehouseCarrierList = (data = {}) => HttpService.get('/api/v2/warehouse/findWarehouseCarriers', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

// 购买面单
export const HttpBuyLabel = (data = {}) => HttpService.post('/api/v2/orderSerivce/buyLabel', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 新购买面单
export const HttpNewBuyLabel = (data = {}) => HttpService.get('/api/v2/orderSerivce/newBuyLabel', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
// 提交退货
export const HttpSubmitReturn= (data = {}) => HttpService.get('/api/v2/orderSerivce/submitReturn', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 预约上门取件、去掉上门取件、获取时间下拉
export const HttpPickReservation = (data = {}) => HttpService.get('/api/v2/orderSerivce/pickReservation', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpCancelReservation = (data = {}) => HttpService.get('/api/v2/orderSerivce/cancelReservation', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })
export const HttpGetReservationDate = (data = {}) => HttpService.get('/api/v2/orderSerivce/getReservationDate', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

